export const CHECKOUT_URL = 'https://metodo-para-padres-de-futbolistas-latam.impultienda.ar/checkout';
export const stats = [{
  value: "5 +2",
  label: "Módulos y Bonos"
}, {
  value: '+250',
  label: 'Páginas en PDF'
}, {
  value: '100%',
  label: 'Material digital'
}, {
  value: "∞",
  label: 'Acceso de por vida'
}];
export const heroTestimonials = [{
  quote: 'No entendía nada de fuerzas básicas: ni cómo funcionan los clubes, ni los permisos, ni la carta. Cuando una academia de Monterrey nos hizo una oferta, ya sabía qué preguntar, qué pedir por escrito y qué no aceptar.',
  name: 'Alejandro M.',
  role: 'Papá de jugador Sub-16 · Monterrey, N.L.'
}, {
  quote: 'Nos habló un supuesto representante y no hallábamos cómo comprobar si era real. El método nos dio un orden claro para revisar todo y también para acompañar a mi hijo sin echarle más presión.',
  name: 'Carolina R.',
  role: 'Mamá de jugador Sub-15 · Guadalajara, Jal.'
}];
export const problems = ['Tu hijo o hija casi no tiene minutos y no sabes cómo platicarlo con el club, ni cuándo conviene buscar otra institución.', 'Aparecen "visores" o representantes y no tienes cómo comprobar si están registrados ante FIFA o si solo te están viendo la cara.', 'Te ponen enfrente un contrato o una carta de compromiso y no sabes qué cláusulas revisar antes de firmar.', 'Les llega una "oportunidad" en Estados Unidos o Europa y no distingues si es real o si es un fraude.', 'No sabes qué derechos tiene un menor de edad en fuerzas básicas según el reglamento de FIFA, que manda por encima de lo que acostumbre el club o la liga local.', 'Quieres acompañar la carrera de tu hijo o hija, pero no sabes por dónde empezar ni qué decisiones tomar primero.'];
export const chapters = [{
  number: '01',
  title: 'Cómo funcionan las fuerzas básicas en México',
  description: 'Entiende quién es quién: FIFA y su reglamento sobre menores, los clubes de Liga MX y Liga de Expansión, las academias y filiales, la FMF, las ligas locales, los visores y los agentes. Cómo se organiza el camino formativo del futbol base y cuál es el rol real de papás y mamás en cada etapa, de los 8 a los 18 años.',
  tags: ['Marco FIFA', 'Clubes y filiales', 'Etapas del jugador', 'Rol de la familia']
}, {
  number: '02',
  title: 'Legalidad: contratos, representantes y todo por escrito',
  description: 'Las reglas FIFA/RSTP y el Reglamento de Agentes de FIFA explicadas en lenguaje simple: son el marco que manda por encima de cualquier costumbre local, y después se suma lo que aplica en México. Cómo cachar visores falsos, visorías patito y representantes sin licencia FIFA, qué cláusulas leer con calma, por qué la carta y cualquier acuerdo deben quedar por escrito y en qué momento conviene consultar a un abogado especializado en derecho deportivo.',
  tags: ['FIFA / RSTP', 'Licencia FIFA de agentes', 'Cláusulas clave', 'Todo por escrito']
}, {
  number: '03',
  title: 'Visibilidad: que el talento se vea y llegue a quien decide',
  description: 'Cómo construir visibilidad real: video de jugadas bien editado, CV deportivo, uso responsable de redes, calendario de torneos y visorías, y contactos verificados. Incluye cómo preparar la exposición ante visores de clubes mexicanos y cómo evaluar rutas hacia la MLS, el college en Estados Unidos o Europa, paso a paso.',
  tags: ['Video y CV deportivo', 'Torneos y visorías', 'Contactos verificados', 'Estrategia con visores']
}, {
  number: '04',
  title: 'Biología y mente: rendimiento sostenible sin quiebres',
  description: 'Maduración biológica, carga de entrenamiento, descanso, nutrición y prevención de lesiones a nivel educativo. Además, cómo acompañar emocionalmente sin convertirte en una fuente de presión, y un semáforo de alertas para saber cuándo frenar, cuándo insistir y cuándo pedir ayuda profesional.',
  tags: ['Maduración y carga', 'Nutrición y descanso', 'Manejo emocional', 'Semáforo de alertas']
}];
export const bonuses = [{
  number: 'Bono 01',
  title: 'EL MANUAL DEL AGENTE Y EL CONTRATO PERFECTO',
  description: 'Plantillas y checklist para revisar contratos y cartas de compromiso: qué preguntar, qué comprobantes pedir, qué focos rojos detectar y cómo documentar todo antes de firmar.',
  originalPrice: 'US$ 13'
}, {
  number: 'Bono 02',
  title: 'VISORÍAS, BECAS Y OPORTUNIDADES INTERNACIONALES',
  description: 'Pasos prácticos para grabar, seleccionar y estructurar videos de forma profesional, además de una estructura de CV deportivo para un contacto efectivo.',
  originalPrice: 'US$ 13'
}];
export const offerChecklist = ['5 módulos completos', 'Más de 250 páginas en PDF', 'El Triángulo de Blindaje: Legalidad, Biología y Visibilidad', 'El manual del agente y el contrato perfecto', 'Visorías, becas y oportunidades internacionales', 'Acceso inmediato de por vida'];
export const testimonials = [{
  initials: 'AM',
  color: '#1d4ed8',
  quote: 'Una academia nos hizo una oferta y por primera vez la pude evaluar con criterio: qué pedir por escrito, qué comprobar con el club y qué dejar en pausa.',
  name: 'Alejandro Mendoza',
  role: 'Papá de jugador Sub-16 · Monterrey, N.L.'
}, {
  initials: 'CR',
  color: '#b45309',
  quote: 'Nos habló un representante que no pudimos comprobar por ningún lado. Con las listas del método le paramos a tiempo y nos evitamos un compromiso que no nos convenía.',
  name: 'Carolina Ramírez',
  role: 'Mamá de jugador Sub-15 · Guadalajara, Jal.'
}, {
  initials: 'PS',
  color: '#15803d',
  quote: 'Antes de firmar la carta, revisamos el documento con las preguntas del módulo de contratos y llevamos las dudas con un abogado. Firmamos con mucha más claridad.',
  name: 'Patricia Salazar',
  role: 'Mamá de jugador de fuerzas básicas · Ciudad de México'
}, {
  initials: 'JQ',
  color: '#7e22ce',
  quote: 'Armamos el video de jugadas y el CV deportivo tal cual la guía, y acomodamos los torneos y visorías del año. Hoy traemos una estrategia, ya no andamos a la deriva.',
  name: 'Julio Quintero',
  role: 'Papá de jugador Sub-17 · Puebla, Pue.'
}, {
  initials: 'MV',
  color: '#be123c',
  quote: 'Nos salió la posibilidad de una prueba del otro lado y no sabíamos ni qué papeles pedir. El método nos ordenó los tiempos, los requisitos y las preguntas correctas.',
  name: 'Mónica Villanueva',
  role: 'Mamá de jugadora Sub-18 · Tijuana, B.C.'
}, {
  initials: 'GC',
  color: '#0f766e',
  quote: 'Mi hijo venía muy cargado entre la escuela y los entrenamientos. Con el semáforo de alertas supimos cuándo bajarle y platicamos con el cuerpo técnico sin conflicto.',
  name: 'Gerardo Canul',
  role: 'Papá de jugador Sub-14 · Mérida, Yuc.'
}];
export const faqs = [{
  question: '¿Sirve si apenas voy entendiendo el mundo de las fuerzas básicas?',
  answer: 'Sí, está pensado exactamente para eso. Explica todo desde cero, con lenguaje claro, sin tecnicismos y con ejemplos del futbol base mexicano.'
}, {
  question: '¿Para qué categorías o edades sirve?',
  answer: 'Está orientado a papás y mamás de jugadores desde las categorías infantiles hasta las Sub-17 y Sub-20, y la firma del primer contrato profesional.'
}, {
  question: '¿Aplica en México?',
  answer: 'Sí. La base son las reglas de FIFA (RSTP y el Reglamento de Agentes), que están por encima de la costumbre de cualquier club o liga, y sobre eso el material se aterriza al contexto mexicano: Liga MX, Liga de Expansión, filiales, ligas locales y la FMF. Como los procedimientos se actualizan, el método te indica siempre verificar primero en los registros de FIFA y después con el club y la federación antes de firmar.'
}, {
  question: '¿Es un producto físico o digital?',
  answer: '100% digital en PDF. No hay envíos. Puedes leerlo desde cualquier dispositivo.'
}, {
  question: '¿Cómo recibo mi compra?',
  answer: 'Inmediatamente después del pago recibes un correo con el enlace de descarga.'
}, {
  question: '¿Tengo que pagar todos los meses?',
  answer: 'No. Es un pago único con acceso de por vida.'
}, {
  question: '¿Qué pasa si no estoy satisfecho?',
  answer: 'Tienes 7 días de garantía. Escribe a solucionesoinformacion@gmail.com.'
}, {
  question: '¿En qué se diferencia de buscar información gratis en internet?',
  answer: 'Lo que hay en internet está disperso, muchas veces desactualizado y casi nunca aplica al futbol base de México. Este método está organizado, ordenado por etapas y listo para usar justo cuando cae una decisión.'
}, {
  question: '¿Esto reemplaza a un abogado?',
  answer: 'No. Este material es educativo y no reemplaza la asesoría de un abogado especializado en derecho deportivo. Te ayuda a entender el proceso, hacer mejores preguntas y saber cuándo consultar con un profesional especializado antes de firmar.'
}, {
  question: '¿Garantiza que mi hijo o hija llegue a ser profesional?',
  answer: 'No, y desconfía de quien lo prometa. Lo que ofrece es más claridad, mejores decisiones, menos riesgo y más control de la familia sobre el proceso.'
}];
export const comparisonRows = [{
  situation: 'Entender cómo funcionan las fuerzas básicas',
  without: 'Puro rumor y datos sueltos de la tribuna',
  with: 'Un mapa claro: reglas FIFA, clubes, filiales y agentes'
}, {
  situation: 'Oferta de una academia o club',
  without: 'Aceptas sin saber qué estás cediendo',
  with: 'Sabes qué preguntar y qué pedir por escrito'
}, {
  situation: 'Te habla un representante',
  without: 'No tienes cómo comprobar si tiene licencia FIFA',
  with: 'Lista de verificación paso a paso lista para usar'
}, {
  situation: 'Antes de firmar la carta o un contrato',
  without: 'Firmas sin entender las cláusulas',
  with: 'Revisas los puntos críticos y consultas a tiempo'
}, {
  situation: 'Invitación a una prueba en el extranjero',
  without: 'No distingues una oportunidad real de un fraude',
  with: 'Criterios claros para evaluarla con calma'
}, {
  situation: 'Visibilidad ante visores',
  without: 'Sin video, sin CV deportivo, sin plan',
  with: 'Video, CV deportivo y calendario de visorías armados'
}, {
  situation: 'Presión y desgaste emocional',
  without: 'La familia le echa más presión sin darse cuenta',
  with: 'Sabes cómo acompañar sin presionar'
}];
